<template>
    <div>
        <tb-skeleton v-if="!initialized" :height="100" :theme="'opacity'" :shape="'radius'" bg-color="#dcdbdc"></tb-skeleton>

        <div v-else-if="user">
            <ValidationObserver ref="permissionform">
                <form @submit.prevent="savePermissions">
                    <div class="row">
                        <div class="col-xl-3">
                            <div class="card">
                                <div class="card-header bg-light">
                                    <h6 class="card-title">Rättigheter (Generella)</h6>
                                </div>
                                <div class="card-body">
                                    <label class="font-weight-semibold">Inloggning</label>
                                    <div class="form-check mb-3">
                                        <label class="form-check-label">
                                            <input type="checkbox" class="form-check-input" v-model="user.allow_remote_login" :true-value="1" :false-value="0">
                                            Tillåt inloggning från okända nätverk (kräver tvåfaktorsautentisering)
                                        </label>
                                    </div>
                                    <div class="form-group" v-if="roles_arr.other.length">
                                        <label class="font-weight-semibold">Roller</label>
                                        <div v-for="(role, r_idx) in roles_arr.other" :key="'r-' + r_idx" class="form-check">
                                            <label class="form-check-label">
                                                <input type="checkbox" class="form-check-input" v-model="user.role_tags" :value="role.tag">
                                                {{ role.name }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="permissions_arr.other.length">
                                        <label class="font-weight-semibold">Rättigheter</label>
                                        <div v-for="(permission, p_idx) in permissions_arr.other" :key="'p-' + p_idx" class="form-check">
                                            <label class="form-check-label">
                                                <input v-if="permission.selected" type="checkbox" class="form-check-input" disabled :checked="permission.selected">
                                                <input v-else type="checkbox" class="form-check-input" v-model="user.permission_tags" :value="permission.tag">
                                                {{ permission.name }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header bg-light">
                                    <h6 class="card-title">Tvåfaktorsautentisering</h6>
                                </div>
                                <div class="card-body">
                                    <div v-if="user.has_enabled_two_factor_authentication">
                                        <div class="alert alert-success border-0">
                                            Tvåfaktorsautentisering aktiv
                                        </div>
                                        <div class="form-group">
                                            <label>SMS-nummer</label>
                                            <ValidationProvider tag="div" class="form-group" vid="two_factor_phone" name="SMS-nummer" v-slot="{ errors }">
                                                <input type="text" class="form-control" v-model="user.two_factor_phone" placeholder="SMS-nummer" :class="{ 'border-danger':errors[0] }">
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                        <limitless-button type="button" btn-class="btn-primary" class="d-block mb-2"
                                                          @click="allowShowQr" ref="btnallowshowqr" icon="icon-qrcode" saved-text="Visas i 24 timmar">Tillåt visning av QR-kod (24 timmar)</limitless-button>
                                        <limitless-button type="button" btn-class="btn-danger" class="d-block"
                                                          @click="disableTwoFactor" ref="btndisabletwofactor" icon="icon-switch">Inaktivera tvåfaktorsautentisering</limitless-button>
                                    </div>
                                    <div v-else>
                                        <div class="alert alert-danger border-0">
                                            Tvåfaktorsautentisering ej aktiv
                                        </div>
                                        <limitless-button type="button" class="btn btn-primary" @click="enableTwoFactor" ref="btnenabletwofactor" icon="icon-switch">Aktivera tvåfaktorsautentisering</limitless-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3">
                            <div class="card">
                                <div class="card-header bg-success" style="color: #fff; background-color: #83212d !important;">
                                    <h6 class="card-title">Supékort (Röda)</h6>
                                </div>
                                <div class="card-body">
                                    <div class="form-group" v-if="roles_arr.red.length">
                                        <label class="font-weight-semibold">Roller</label>
                                        <div v-for="(role, r_idx) in roles_arr.red" :key="'r-' + r_idx" class="form-check">
                                            <label class="form-check-label">
                                                <input type="checkbox" class="form-check-input" v-model="user.role_tags" :value="role.tag">
                                                {{ role.name }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="permissions_arr.red.length">
                                        <label class="font-weight-semibold">Rättigheter</label>
                                        <div v-for="(permission, p_idx) in permissions_arr.red" :key="'p-' + p_idx" class="form-check">
                                            <label class="form-check-label">
                                                <input v-if="permission.selected" type="checkbox" class="form-check-input" disabled :checked="permission.selected">
                                                <input v-else type="checkbox" class="form-check-input" v-model="user.permission_tags" :value="permission.tag">
                                                {{ permission.name }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3">
                            <div class="card">
                                <div class="card-header bg-light" style="color: #fff; background-color: #3a4b55 !important;">
                                    <h6 class="card-title">Newport (Grå)</h6>
                                </div>
                                <div class="card-body">
                                    <div class="form-group" v-if="roles_arr.grey.length">
                                        <label class="font-weight-semibold">Roller</label>
                                        <div v-for="(role, r_idx) in roles_arr.grey" :key="'r-' + r_idx" class="form-check">
                                            <label class="form-check-label">
                                                <input type="checkbox" class="form-check-input" v-model="user.role_tags" :value="role.tag">
                                                {{ role.name }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="permissions_arr.grey.length">
                                        <label class="font-weight-semibold">Rättigheter</label>
                                        <div v-for="(permission, p_idx) in permissions_arr.grey" :key="'p-' + p_idx" class="form-check">
                                            <label class="form-check-label">
                                                <input v-if="permission.selected" type="checkbox" class="form-check-input" disabled :checked="permission.selected">
                                                <input v-else type="checkbox" class="form-check-input" v-model="user.permission_tags" :value="permission.tag">
                                                {{ permission.name }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="roles_arr.project.length || permissions_arr.project.length" class="col-xl-3">
                            <div class="card">
                                <div class="card-header bg-light">
                                    <h6 class="card-title">Project</h6>
                                </div>
                                <div class="card-body">
                                    <div class="form-group" v-if="roles_arr.project.length">
                                        <label class="font-weight-semibold">Roller</label>
                                        <div v-for="(role, r_idx) in roles_arr.project" :key="'r-' + r_idx" class="form-check">
                                            <label class="form-check-label">
                                                <input type="checkbox" class="form-check-input" v-model="user.role_tags" :value="role.tag">
                                                {{ role.name }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="permissions_arr.project.length">
                                        <label class="font-weight-semibold">Rättigheter</label>
                                        <div v-for="(permission, p_idx) in permissions_arr.project" :key="'p-' + p_idx" class="form-check">
                                            <label class="form-check-label">
                                                <input v-if="permission.selected" type="checkbox" class="form-check-input" disabled :checked="permission.selected">
                                                <input v-else type="checkbox" class="form-check-input" v-model="user.permission_tags" :value="permission.tag">
                                                {{ permission.name }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3">
                            <div class="card">
                                <div class="card-header bg-light">
                                    <h6 class="card-title">Gamla systemen</h6>
                                </div>
                                <div class="card-body">
                                    <div class="form-group">
                                        <label class="font-weight-semibold">Access Areas</label>
                                        <div v-for="(area, a_idx) in access_areas" :key="'area-' + a_idx" class="form-check">
                                            <label class="form-check-label">
                                                <input type="checkbox" class="form-check-input" v-model="user.user_access_ids" :value="area.AccessID">
                                                <span v-html="area.AccessName"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </ValidationObserver>

            <div class="d-flex justify-content-end">
                <limitless-button ref="btnsavepermissions" type="button" @click="savePermissions" :busy="busy_saving" icon="icon-floppy-disk">Save</limitless-button>
            </div>
        </div>
        <div v-else-if="not_found">
            <i>Användaren finns inte</i>
        </div>
        <div v-else>
            <i>Något gick fel...</i>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import getError from '@services/ErrorHelper';
import Cache from '@services/Cache';

export default {
    components: {
        LimitlessButton,
    },
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
    },
    data: () => ({
        initialized: false,
        busy_saving: false,
        not_found: false,
        user: null,
        permissions: [],
        roles: [],
        access_areas: [],
    }),
    mounted() {
        this.getUser();
        this.getPermissions();
        this.getRoles();
        this.getAccessAreas();
    },
    methods: {
        getUser() {
            apiClient.get('/vue/users/' + this.id + '')
                .then((response) => {
                    this.user = response.data.user;
                })
                .catch((error) => {
                    const { status } = error.response;
                    if (status === 404) {
                        this.not_found = true;
                    }
                })
                .finally(() => {
                    this.initialized = true;
                });
        },
        async savePermissions() {
            const isValid = await this.$refs.permissionform.validate();
            if (isValid) {
                this.busy_saving = true;
                await apiClient.post('/vue/users/' + this.id + '/permissions', this.user)
                    .then((response) => {
                        this.user = response.data.user;
                        this.$refs.btnsavepermissions.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.permissionform.setErrors(parsederror);
                        }
                        this.$refs.btnsavepermissions.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
        enableTwoFactor() {
            apiClient.post('/vue/users/' + this.user.UserID + '/twofactor', {
                enabled: true,
                showqr: true,
                two_factor_phone: this.user.two_factor_phone,
            }).then((response) => {
                this.user.two_factor_phone = response.data.user.two_factor_phone;
                this.user.has_enabled_two_factor_authentication = response.data.user.has_enabled_two_factor_authentication;
                this.$refs.btnenabletwofactor.triggerSaved();
            }).catch((error) => {
                const parsederror = getError(error);
                if (typeof parsederror === 'object') {
                    this.$refs.permissionform.setErrors(parsederror);
                }
                this.$refs.btnenabletwofactor.triggerFailed();
            });
        },
        disableTwoFactor() {
            apiClient.post('/vue/users/' + this.user.UserID + '/twofactor', {
                enabled: false,
                two_factor_phone: this.user.two_factor_phone,
            }).then((response) => {
                this.user.two_factor_phone = response.data.user.two_factor_phone;
                this.user.has_enabled_two_factor_authentication = response.data.user.has_enabled_two_factor_authentication;
                this.$refs.btndisabletwofactor.triggerSaved();
            }).catch((error) => {
                const parsederror = getError(error);
                if (typeof parsederror === 'object') {
                    this.$refs.permissionform.setErrors(parsederror);
                }
                this.$refs.btndisabletwofactor.triggerFailed();
            });
        },
        allowShowQr() {
            apiClient.post('/vue/users/' + this.user.UserID + '/twofactor', {
                showqr: true,
            }).then((response) => {
                this.user.two_factor_phone = response.data.user.two_factor_phone;
                this.user.has_enabled_two_factor_authentication = response.data.user.has_enabled_two_factor_authentication;
                this.$refs.btnallowshowqr.triggerSaved();
            }).catch((error) => {
                const parsederror = getError(error);
                if (typeof parsederror === 'object') {
                    this.$refs.permissionform.setErrors(parsederror);
                }
                this.$refs.btnallowshowqr.triggerFailed();
            });
        },
        getPermissions() {
            if (Cache.get('user-permissions')) {
                this.permissions = Cache.get('user-permissions');
            } else {
                apiClient.get('/vue/users/permissions')
                    .then((response) => {
                        this.permissions = response.data;
                        Cache.set('user-permissions', response.data);
                    });
            }
        },
        getRoles() {
            if (Cache.get('user-roles')) {
                this.roles = Cache.get('user-roles');
            } else {
                apiClient.get('/vue/users/roles')
                    .then((response) => {
                        this.roles = response.data;
                        Cache.set('user-roles', response.data);
                    });
            }
        },
        getAccessAreas() {
            if (Cache.get('user-access-areas')) {
                this.access_areas = Cache.get('user-access-areas');
            } else {
                apiClient.get('/vue/users/access_areas')
                    .then((response) => {
                        this.access_areas = response.data;
                        Cache.set('user-access-areas', response.data);
                    });
            }
        },
    },
    computed: {
        permissions_arr() {
            const arr = {
                red: [], grey: [], project: [], other: [],
            };
            let arrLockedPermissions = [];
            if (this.user.role_tags) {
                this.user.role_tags.forEach((tag) => {
                    if (this.roles[tag]) {
                        arrLockedPermissions = arrLockedPermissions.concat(this.roles[tag].permissions);
                    }
                });
            }
            Object.entries(this.permissions).forEach((entry) => {
                const [key, permission] = entry;
                if (key.startsWith('red')) {
                    arr.red.push({ name: permission.name, tag: key, selected: (arrLockedPermissions.includes(key)) });
                } else if (key.startsWith('grey')) {
                    arr.grey.push({ name: permission.name, tag: key, selected: (arrLockedPermissions.includes(key)) });
                } else if (key.startsWith('project')) {
                    arr.project.push({ name: permission.name, tag: key, selected: (arrLockedPermissions.includes(key)) });
                } else {
                    arr.other.push({ name: permission.name, tag: key, selected: (arrLockedPermissions.includes(key)) });
                }
            });
            return arr;
        },
        roles_arr() {
            const arr = {
                red: [], grey: [], project: [], other: [],
            };
            Object.entries(this.roles).forEach((entry) => {
                const [key, role] = entry;
                if (key.startsWith('red')) {
                    arr.red.push({ name: role.name, tag: key, selected: false });
                } else if (key.startsWith('grey')) {
                    arr.grey.push({ name: role.name, tag: key, selected: false });
                } else if (key.startsWith('project')) {
                    arr.project.push({ name: role.name, tag: key, selected: false });
                } else {
                    arr.other.push({ name: role.name, tag: key, selected: false });
                }
            });
            return arr;
        },
    },
};

</script>
